import request from '../../config/axiosConfig';
import {
  GET_LIST_FEEDBACK_FEATURE_CONFIGS,
  CREATE_FEEDBACK_FEATURE_CONFIG,
  UPDATE_FEEDBACK_FEATURE_CONFIG,
  DELETE_FEEDBACK_FEATURE_CONFIG,
} from '../../constants/apiEndPoint';

const feedbackFeatureConfigService = {
  getList: async (params) => {
    const { data } = await request({ url: GET_LIST_FEEDBACK_FEATURE_CONFIGS, method: 'POST', data: params });
    return data;
  },

  create: async (dataBody) => {
    const { data } = await request({ url: CREATE_FEEDBACK_FEATURE_CONFIG, method: 'POST', data: dataBody });
    return data;
  },

  update: async (id, dataBody) => {
    const { data } = await request({ url: UPDATE_FEEDBACK_FEATURE_CONFIG, method: 'POST', data: { ...dataBody, id } });
    return data;
  },

  delete: async (id) => {
    const { data } = await request({ url: DELETE_FEEDBACK_FEATURE_CONFIG, method: 'POST', data: { id } });
    return data;
  },
};

export default feedbackFeatureConfigService;
